import React, { useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { useLocation } from 'react-router-dom';
import paginationFactory, { PaginationProvider, PaginationListStandalone } from 'react-bootstrap-table2-paginator';

const Container = ({ columns,handlePageChange, data = [] }) => {
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const location = useLocation();
    const [total ,settotal] = React.useState(0);
    // search params
    const handleTableChange = (type, { page, sizePerPage,...args }) => {
        const lastPage = Math.ceil(total / sizePerPage);
        let querypage = Number.isNaN(page) ? lastPage : page;

        // the query page
        setPage(querypage);
        setSizePerPage(sizePerPage);
        let searchparams = new URLSearchParams(location.search);

        const allsearchparams = Object.fromEntries(searchparams.entries());
        handlePageChange({ page: querypage, limit: sizePerPage , ...allsearchparams }).then((response)=>{
            settotal(response.totalCount);
        });
    };
    // React.useEffect(()=>{
    //     if (initData) {
    //         handleTableChange(null ,{ page: 1, sizePerPage: 10 });
    //         setcurPageData(initData);
    //     }
    // }, [initData]);
    React.useEffect(() => {
        const handler = setTimeout(() => {
            handleTableChange(null, { page: 1, sizePerPage });
        }, 300);

        return () => {
            clearTimeout(handler); // cleanup to cancel previous debounce if location.search changes again
        };
    }, [location.search]);
    return (
        <PaginationProvider
            pagination={paginationFactory({
                custom: true,
                page,
                sizePerPage,
                totalSize: total
            })}
        >
            {
                ({ paginationProps, paginationTableProps }) => (
                    <div>
                        <BootstrapTable
                            remote
                            keyField="_id"
                            data={data}
                            columns={columns}
                            onTableChange={handleTableChange}
                            {...paginationTableProps}
                        />
                        <div className="space-between-box">
                            <div>
                                <p>Page: {paginationProps.page}</p>
                                <p>Size Per Page: {paginationProps.sizePerPage}</p>
                            </div>
                            <PaginationListStandalone {...paginationProps} />

                        </div>

                    </div>
                )
            }
        </PaginationProvider>

    );
};

export default Container;
